<template>
  <template v-if="isEnabled">
    <app-button
      v-if="hasAnAlert"
      color="dark"
      data-cy-delete-course-session-alert
      :icon="variant === 'link' ? undefined : 'ph:bell-simple-slash-fill'"
      :size="size"
      tag="span"
      :variant="variant === 'link' ? variant : 'tonal'"
      @click="deleteAlert"
    >
      {{ $t("course_session_alert.deletion.cta_label") }}
    </app-button>

    <growth-contact-button
      v-else
      v-track="'course_new_session_alert_clicked'"
      v-bind="contactFlowMetadata"
      :color="color"
      :confirmation-toast="false"
      data-cy-create-course-session-alert
      :icon="variant === 'link' ? undefined : 'ph:bell-simple-ringing-bold'"
      :redirect="contactFormRedirect"
      :size="size"
      skip-form-if-known-user
      :variant="variant"
      @skipped="createAlert({ email: $event.email! })"
    >
      {{ $t("course_session_alert.creation.cta_label") }}
    </growth-contact-button>
  </template>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

import type { CoursePageView } from "~/business-areas/course/course.model";
import { useCourseNewSessionAlert } from "~/business-areas/course-session/composables/course-new-session-alert.hook";

const isEnabled = useFeatureFlag("course_session_alert");

const properties = defineProps<
  ButtonProps & {
    course: CoursePageView;
  }
>();

const {
  createAlert,
  deleteAlert,
  hasAnAlert,
  contactFormRedirect,
  contactFlowMetadata,
} = useCourseNewSessionAlert(properties.course);
</script>
